import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ServiceCards from "./servicecard";
import Particle from "../Particle";
import fullstack from "../../Assets/service/fullstack.jpg";
import custom from "../../Assets/service/custom.jpeg";
import restfullapi from "../../Assets/service/restfullapi.jpeg";
import fixme from "../../Assets/service/fixme.jpeg";
import websocket from "../../Assets/service/websocket.png";
import integration from "../../Assets/service/integration.jpeg";
import database from "../../Assets/service/database.jpeg";
import deployment from "../../Assets/service/deployment.png";
import wordpress from "../../Assets/service/wordpress.jpeg";
function Service() {
  return (
    <Container fluid className="service-section">
      <Particle />
      <Container>
        <h1 className="service-heading">
          My <strong className="purple">Service </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are <strong className="purple">Service </strong>that i provide.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={fullstack}
              title="Full-Stack Web Development"
              description="Craft dynamic web applications using the MERN stack for a seamless user experience. From frontend design with React.js to backend logic with Node.js and Express.js, I deliver end-to-end solutions"
            />
          </Col>

          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={custom}
              title="Custom Solutions"
              description="Tailor-made solutions to meet your business needs. I specialize in building scalable applications that align with your vision, providing a competitive edge in the digital landscape."
              
            />
          </Col>

          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={restfullapi}
              title="RESTful API Development"
              description="Designing and implementing efficient RESTful APIs using Node.js and Express.js. Ensure smooth communication between your frontend and backend, enabling seamless data exchange and integration."
              
            />
          </Col>

          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={fixme}
              title="Maintenance and Updates"
              description="Ongoing support to keep your applications running smoothly. I address bugs promptly, implement updates, and provide regular maintenance to ensure a reliable user experience"
              />
          </Col>

          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={websocket}
              title="Real-time Interactivity"
              description="Implement real-time features using cutting-edge technologies like WebSockets. Enhance user engagement with live updates and interactive functionalities that keep your audience hooked."
               
            />
          </Col>
         
          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={integration}
              title="Third-Party Integrations"
              description="Enhance your application's capabilities by seamlessly integrating third-party services and APIs. Expand functionality and stay ahead of the curve with effortless connections to external tools"
              />
          </Col>

          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={database}
              title="Database Mastery"
              description="Expertise in MongoDB for secure and efficient data storage. I design database schemas that optimize performance and scalability while ensuring the integrity of your valuable data"
               
            />
          </Col>
          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={deployment}
              title="Deployment Excellence"
              description="Seamlessly deploy your applications on popular cloud platforms such as AWS or Heroku. I ensure proper configuration for production environments, guaranteeing optimal performance and reliability."
                          
            />
          </Col>
          <Col md={4} className="service-card">
            <ServiceCards
              imgPath={wordpress}
              title="Word press"
              description="I built WordPress websites with expertise in creating custom themes, plugins, and integrations. I can help you create a WordPress website that is both visually appealing and functional, and that meets the specific needs of your business"
                          
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Service;
